import React, { Component } from 'react'
import {
    AssessmentContainer,
    AssessmentBody,
    AssessmentContent,
    AssessmentNavigationPrevious,
    AssessmentNavigationNext,
    AssessmentFooter,
    AssessmentContentAction,
    AssessmentContentActionButton
} from '../common';
import { Box } from '../../../third-party-components/material-ui';
import { getLang, translateLabel } from '../common/task-utility';
import { TaskDialog, TaskProgress } from '../common/task-controls';
import history from '../../../routes/history';
import { isMobile } from 'react-device-detect';

const createTask = (WrappedComponent) => {
    return class Task extends Component {
        constructor(props) {
            super(props);

            this.state = { startDate: null, showWarningMessage: false, showSkipRemainingItems: false };

            this.handleClickPrevious = this.handleClickPrevious.bind(this);
            this.handleClickNext = this.handleClickNext.bind(this);
            this.handleCloseWarning = this.handleCloseWarning.bind(this);
            this.handleForceNext = this.handleForceNext.bind(this);
            this.handleCloseSkipRemainingItems = this.handleCloseSkipRemainingItems.bind(this);
            this.handleNextSkipRemainingItems = this.handleNextSkipRemainingItems.bind(this);
            this.getTaskDialogHeaderText = this.getTaskDialogHeaderText.bind(this);
        }

        updateDimensions = () => {
          if (window.innerHeight <= 640) {
            this.setState({ isMobile: true });
          } else {
            this.setState({ isMobile: false });
          }
        }
    
        componentWillMount() {
          this.updateDimensions();
        }
    
        componentWillUnmount() {
          window.removeEventListener("resize", this.updateDimensions);
        }

        componentDidMount() {
            this.setState({ startDate: new Date() });

            window.addEventListener("resize", this.updateDimensions);
        }

        handleClickPrevious() {
            const { taskLink, previousLink, history, saveData } = this.props;

            const currentIndex = this.getCurrentIndex();

            if (currentIndex > 0) {
                //saveData();
                history.push(`${taskLink}/${currentIndex}`);
            } else {
                // if (previousLink.includes("Tasks")) {
                //     saveData();
                // }

                history.push(previousLink);
            }
        }

        handleClickNext() {
            const task = this.getCurrentTask();

            if (task.isSkipRemainingPractice && this.canGoNext()) {
                this.openSkipRemainingItemsDialog();
            } else {
                this.doHandleClickNext();
            }
        }

        doHandleClickNext() {
            if (this.canGoNext()) {
                this.setState({disableArrows: true});
                this.goNext();
            } else {
                this.setState({ showWarningMessage: true });
            }
        }

        canGoNext() {
            const task = this.getCurrentTask();
            return WrappedComponent.prototype.canGoNext(task);
        }

        handleForceNext() {
            const { setDefaultTaskResponse, taskType, subTaskType  } = this.props;
            const task = this.getCurrentTask();

            setDefaultTaskResponse(task, taskType, subTaskType);
            this.setState({ showWarningMessage: false });


            if (task.isSkipRemainingPractice) {
                this.openSkipRemainingItemsDialog();
            }
            else {
                this.goNext();
            }
        }

        goNext() {
            const { tasks, taskLink, nextLink, saveData, saveScreenDuration } = this.props;

            const currentIndex = this.getCurrentIndex();

            if (currentIndex < tasks.length - 1) {
                //saveData();
                saveScreenDuration();
                history.push(`${taskLink}/${currentIndex + 2}`);
            } else {
                // if (nextLink.includes("Tasks")) {
                //     saveData();
                // }
                history.push(nextLink);
            }

            this.forceUpdate();
        }

        handleCloseWarning() {
            this.setState({ showWarningMessage: false });
        }

        getCurrentTask() {
            const { tasks } = this.props;
            const currentIndex = this.getCurrentIndex();
            return tasks[currentIndex];
        }

        getCurrentIndex() {
            let currentIndex = 0;

            const { match } = this.props;
            const index = match.params.index;

            if (index !== undefined) {
                currentIndex = index - 1;
            }

            return currentIndex;
        }

        canSkipTask() {
            return WrappedComponent.prototype.canSkipTask && WrappedComponent.prototype.canSkipTask();
        }

        getSkipText() {
            if (WrappedComponent.prototype.getSkipTaskText) {
                return WrappedComponent.prototype.getSkipTaskText();
            } else {
                return "Click Next to skip the remaining tasks or Close to go to the next tasks";
            }
        }

        getTaskDialogHeaderText() {
            const { taskType } = this.props;
                return 'WARNING'
        }

        openSkipRemainingItemsDialog() {
            this.setState({ showSkipRemainingItems : true });
        }

        closeSkipRemainingItemsDialog() {
            this.setState({ showSkipRemainingItems : false });
        }

        handleCloseSkipRemainingItems() {
            const { resetSkippedTasks, taskType, subTaskType } = this.props;
            const task = this.getCurrentTask();

            resetSkippedTasks(task, taskType, subTaskType);
            this.closeSkipRemainingItemsDialog();
            this.goNext();
        }

        handleNextSkipRemainingItems() {
            const { nextLink, skipRemainingTasks, taskType, subTaskType, saveData } = this.props;
            const task = this.getCurrentTask();

            skipRemainingTasks(task, taskType, subTaskType);
            this.closeSkipRemainingItemsDialog();

            // if (nextLink.includes("Tasks")) {
            //     saveData();
            // }

            history.push(nextLink);
        }

        render() {
            const { tasks, taskType, footerLabel, versionID } = this.props;
            const lang = getLang(versionID);
            let taskLabel = footerLabel;

            if (tasks === undefined || tasks.length === 0) {
                return null;
            }

            const currentIndex = this.getCurrentIndex();
            const task = tasks[currentIndex];

            if (!taskLabel) {
                taskLabel = `${currentIndex + 1} OF ${tasks.length}`;
            }

            return (
                <React.Fragment>
                    <TaskDialog visible={this.state.showWarningMessage} onYes={this.handleForceNext} onNo={this.handleCloseWarning} lang={lang}>
                        {lang === 'fr' ? (
                            <div>
                                <span style={{color: '#153A62', fontWeight: 'bold'}}>Êtes-vous certain d'ignorer cette question?</span>
                                <div style={{marginTop: '30px'}}>
                                    Pour répondre à cette question, sélectionnez « Non ». Si vous souhaitez ne pas répondre et laisser un blanc, sélectionnez « Oui » pour continuer sur la prochaine page.
                                </div>
                            </div>
                        ) : lang === 'es' ? (
                            <div>
                                <span style={{color: '#153A62', fontWeight: 'bold'}}>¿Está seguro de que quiere omitir este ítem?</span>
                                <div style={{marginTop: '30px'}}>
                                    Seleccione "No" para responder a este ítem. Si prefiere dejarlo en blanco, seleccione "Sí" para continuar a la siguiente pantalla. 
                                </div>
                            </div>
                        ) : (
                            <div>
                                <span style={{color: '#153A62', fontWeight: 'bold'}}>Are you sure you want to skip this item?</span>
                                <div style={{marginTop: '30px'}}>
                                    Select No to respond to this item. If you want to leave the item blank, select Yes to continue to the next screen.
                                </div>
                            </div>
                        )}
                    </TaskDialog>
                    <TaskDialog visible={this.state.showSkipRemainingItems && this.canSkipTask()} onClose={this.handleCloseSkipRemainingItems} onNext={this.handleNextSkipRemainingItems} header={this.getTaskDialogHeaderText}>
                        {this.getSkipText()}
                    </TaskDialog>
                    <AssessmentContainer>
                        <AssessmentBody>
                            <AssessmentContent>
                                <WrappedComponent task={task} {...this.props} />
                                <div className='progress-label'>{translateLabel(taskLabel, versionID)}</div>
                            </AssessmentContent>
                        </AssessmentBody>
                        <AssessmentContentAction>
                            <AssessmentContentActionButton styleType='arrows' onClick={this.handleClickPrevious}>{"<"}</AssessmentContentActionButton>
                            <AssessmentContentActionButton styleType='arrows' onClick={this.handleClickNext}>{">"}</AssessmentContentActionButton>
                        </AssessmentContentAction>
                        <AssessmentFooter><TaskProgress completed={WrappedComponent.prototype.getCompletedPercentage(tasks)} /></AssessmentFooter>
                    </AssessmentContainer>
                </React.Fragment>
            )
        }
    }
}

export default createTask;